import { render } from "./designCheckboxPreview.vue?vue&type=template&id=4964ecf4&scoped=true"
import script from "./designCheckboxPreview.vue?vue&type=script&lang=js"
export * from "./designCheckboxPreview.vue?vue&type=script&lang=js"

import "./designCheckboxPreview.vue?vue&type=style&index=0&id=4964ecf4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4964ecf4"]])

export default __exports__